import { render, staticRenderFns } from "./TariffzoneDataGrid.vue?vue&type=template&id=90cac0be&scoped=true&"
import script from "./TariffzoneDataGrid.vue?vue&type=script&lang=js&"
export * from "./TariffzoneDataGrid.vue?vue&type=script&lang=js&"
import style0 from "./TariffzoneDataGrid.vue?vue&type=style&index=0&id=90cac0be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cac0be",
  null
  
)

export default component.exports